var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2a3 3 0 0 1 3 3h1a3 3 0 0 1 0 6H7a3 3 0 1 1 0-6h.268a2 2 0 0 1 2.81-.685A3.001 3.001 0 0 1 13 2zm-2.05 10.126-1.84 4.6a.2.2 0 0 0 .185.274h1.428a.2.2 0 0 1 .19.263L9.39 21.831a.2.2 0 0 0 .35.183l5.02-6.694a.2.2 0 0 0-.16-.32h-2.226a.2.2 0 0 1-.167-.31l1.586-2.38a.2.2 0 0 0-.167-.31h-2.49a.2.2 0 0 0-.186.126z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/lightning.1dd659234ad16084c851bfd263a8736b.svg";
export { ForwardRef as ReactComponent };